<template>
  <a-modal
    title='可视化图表'
    :visible='visible'
    :confirm-loading='confirmLoading'
    @ok='handleOk'
    @cancel='handleCancel'
    width='800'
  >
    <div class='bigbox'>
      <div class='productNameInstall'>
        <div style='margin-left: 5px'><h2>产品名称：{{ productName }}</h2></div>
        <div style='margin-left: 5px' v-show='showDayTitle'><h2>日期：{{ startTime }}</h2></div>
        <div class='custinstallContentbox2'
             style='display: flex;flex-direction: column;justify-content: space-around;'>
          <div class='custInstall-chart-one' style='width:96%; height: 800px; margin-bottom: 100px'></div>
          <div class='custInstall-chart-two' style='width:96%; height: 800px;'></div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getConvertInstallData } from '@/webpublicapi/order'

export default {
  data() {
    return {
      visible: false,
      confirmLoading: true,
      showDayTitle: false,//只有一天数据的时候展示日期 默认false
      productName: '产品名',
      startTime: '',
      endTime: '',
      VersionArr: [],//版本号
      VersionDataArr: [],//版本号及对应数组数据
      VersionPercentDataArr: []//版本号及对应百分比数据
    }
  },
  created() {
    console.log('created')
  },
  mounted() {
    this.confirmLoading = true
  },
  methods: {
    clearEcharts() {
      console.log('清空echartsvbv')
      const clearDom = document.querySelector('.custInstall-chart-one')
      const clearDom2 = document.querySelector('.custInstall-chart-two')
      console.log('clearDom--->', clearDom)
      console.log('clearDom2--->', clearDom2)
      if (!(clearDom || clearDom2)) {
        console.log('不清空')
      } else {
        console.log('清空')
        this.$echarts.init(document.querySelector('.custInstall-chart-one')).clear()
        this.$echarts.init(document.querySelector('.custInstall-chart-two')).clear()
      }
      console.log('清空echarts')
    },
    openModal() {
      console.log('open')
      this.visible = true
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    //请求图的数据
    sendRequest(query) {
      console.log('准备发请求的参数', query)
      // 发送请求的逻辑
      query.pageSize = 100
      getConvertInstallData(query).then((res) => {
        if (res.code === 1000) {
          this.confirmLoading = false
          //获取产品名字
          this.productName = res.data.rows[0].appName
          const datalist = res.data.rows
          console.log('准备处理的数据-->', datalist)
          //选择一天---->时间
          this.startTime = datalist[datalist.length - 1].dataDt
          console.log(' this.startTime ', this.startTime)
          //存储各个版本数据的数组
          // const versionListData = (datalist.map(datalist => datalist.dataDetails))
          datalist[0].appVersion = '总计'
          const versionListData = datalist[0].dataDetails
          console.log('存储各个版本数据的数组----->', versionListData)
          versionListData.unshift(datalist[0])
          console.log('存储各个版本数据+总计的数组----->', versionListData)
          this.VersionArr = versionListData.map(obj => obj.appVersion)
          console.log('存储版本名称的数组+统计----->', this.VersionArr)
          this.VersionDataArr = versionListData.reduce((acc, curr) => {
            const {
              appVersion,
              installs,
              regCount,
              jsonCount,
              idimageCount,
              faceCount,
              idnoCount,
              basicCount,
              linkmanCount,
              bankcardCount,
              applyCount,
              accessCount,
              loanCount
            } = curr
            if (!acc[appVersion]) {
              acc[appVersion] = [installs, regCount, jsonCount, idimageCount, faceCount, idnoCount, basicCount, linkmanCount, bankcardCount, applyCount, accessCount, loanCount]
            }
            return acc
          }, {})
          console.log('数值:版本以及版本对应数据---->', this.VersionDataArr)


          const percentArr = versionListData.reduce((acc, curr) => {
            const {
              appVersion,
              optRegRate,
              regApplyRate,
              installApplyRate,
              jsonBeforeRate,
              idCardBeforeRate,
              faceBeforeRate,
              baseBeforeRate,
              linkBeforeRate,
              bankCardBeforeRate,
              applyBeforeRate,
              applyAccessRate,
              loanBeforeRate,
              cardRegisterRate
            } = curr
            if (!acc[appVersion]) {
              acc[appVersion] = [
                optRegRate,
                regApplyRate,
                installApplyRate,
                jsonBeforeRate,
                idCardBeforeRate,
                faceBeforeRate,
                baseBeforeRate,
                linkBeforeRate,
                bankCardBeforeRate,
                applyBeforeRate,
                applyAccessRate,
                loanBeforeRate,
                cardRegisterRate]
            }
            return acc
          }, {})
          console.log('百分比:版本以及版本对应数据---->', percentArr)
          this.VersionPercentDataArr = Object.fromEntries(
            Object.entries(percentArr).map(([key, value]) => {
              const newValue = value.map(item => parseFloat(item, 10))
              return [key, newValue]
            })
          )
          console.log('去掉百分号-->', this.VersionPercentDataArr)

          this.drawOneDay()
        }
      }).catch(e => {

      })
    },
    //一天的画法
    drawOneDay() {
      console.log('调用了1天画图的方法')
      this.showDayTitle = true
      /*-----------------------------------------------------------数值图---------------------------------------------------------*/
      var chartDom = document.querySelector('.custInstall-chart-one')
      console.log('chartDom', chartDom)
      var myChart = this.$echarts.init(chartDom)
      var option
      var dataMap = {}

      function dataFormatter(obj) {
        var pList = ['安装', '注册', '大JSON', '身份证照片', '人脸照片', '身份证信息', '基本信息', '联系人', '银行卡信息', '申请', '过件', '放款']
        return obj
      }

      dataMap.dataVersion = dataFormatter(this.VersionDataArr)

      const showtite = this.VersionArr.map(item => ({
        title: { text: item !== '总计' ? '版本号:' + item : item },
        series: [
          { data: dataMap.dataVersion[item] }
        ]
      }))

      // console.log('showtite--->', showtite)
      option = {
        baseOption: {
          timeline: {
            // top: '50px',
            axisType: 'category',
            autoPlay: false,
            playInterval: 2000,
            //存储小版本号的数组
            data: this.VersionArr,
            label: {
              normal: {
                textStyle: {
                  fontSize: 14
                }
              },
              emphasis: {
                textStyle: {
                  fontSize: 14
                }
              }
            }
          },
          tooltip: {
            formatter: function(params) {
              // console.log('params--->', params)
              return params[0].marker + ' ' + params[0].axisValueLabel + ' ' + params[0].value
            }
          },
          legend: {
            left: 'right',
            // data: [this.productName],
            selected: {},
            textStyle: {
              fontSize: 16
            }

          },
          calculable: true,
          grid: {
            top: 80,
            bottom: 100,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true,
                  formatter: function(params) {
                    return params.value.replace('\n', '')
                  }
                }
              }
            }
          },
          xAxis: [
            {
              type: 'category',
              axisLabel: { interval: 0, fontSize: 14 },
              data: [
                '安装',//installs
                '注册',//regCount
                '大JSON',//jsonCount
                '身份证照片',//idimageCount
                '人脸照片',//faceCount
                '身份证信息',//idnoCount
                '基本信息',//basicCount
                '联系人',//linkmanCount
                '银行卡信息',//bankcardCount
                '申请',//applyCount
                '过件',//accessCount
                '放款'//loanCount
              ],
              splitLine: { show: false }
            }
          ],
          yAxis: {
            axisLabel: {
              fontSize: 18
            }
          },
          series: [
            {
              name: this.productName,
              type: 'bar',
              label: {
                position: 'top', // 标签位置
                show: true,
                color: 'red', // 文字颜色
                formatter: function(params) {
                  if (params.value == 0.00 || params.value == 0) {
                    return '{a|' + params.value + '}'
                  } else {
                    return '{b|' + params.value + '}'
                  }
                },
                rich: {
                  a: {
                    color: 'red',
                    fontSize: 18,
                    align: 'center'
                  },
                  b: {
                    color: 'black',
                    fontSize: 16,
                    align: 'center'
                  }


                }
              }
            }
          ]
        },
        //小版本号标题变化
        options: showtite
      }
      option && myChart.setOption(option)
      /*--------------------------------------------------------百分比图-------------------------------------------------------*/
      var chartDom2 = document.querySelector('.custInstall-chart-two')
      console.log('chartDom2', chartDom2)
      var myChart2 = this.$echarts.init(chartDom2)
      var option2
      var dataMap2 = {}

      function dataFormatter2(obj) {
        var pList = ['注册率', '注册申贷率', '安装申贷率', 'JSON率/前', '身份证照片率/前', '人脸照片率/前', '基本信息率/前', '联系人率/前', '银行卡信息率/前', '申请率/前', '过件率', '放款率', '注册-绑卡转化率/前']
        return obj
      }

      dataMap2.dataVersion = dataFormatter2(this.VersionPercentDataArr)

      const showtite2 = this.VersionArr.map(item => ({
        title: { text: item !== '总计' ? '版本号 : ' + item : item },
        series: [
          { data: dataMap2.dataVersion[item] }
        ]
      }))

      option2 = {
        baseOption: {
          timeline: {
            axisType: 'category',
            autoPlay: false,
            playInterval: 2000,
            //存储小版本号的数组
            data: this.VersionArr,
            label: {
              normal: {
                textStyle: {
                  fontSize: 14
                }
              },
              emphasis: {
                textStyle: {
                  fontSize: 14
                }
              }
            }
          },
          tooltip: {
            formatter: function(params) {
              // console.log('params--->', params)
              return params[0].marker + ' ' + params[0].axisValueLabel + ' ' + params[0].value + '%'
            }
          },
          legend: {
            left: 'right',
            // data: [this.productName],
            selected: {},
            textStyle: {
              fontSize: 16
            }
          },
          calculable: true,
          grid: {
            top: 80,
            bottom: 100,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true,
                  formatter: function(params) {
                    return params.value.replace('\n', '')
                  }
                }
              }
            }
          },
          xAxis: [
            {
              type: 'category',
              axisLabel: { interval: 0, fontSize: 14 },
              data: [
                '注册率',
                '注册申贷率',
                '安装申贷率',
                'JSON率/前',
                '身份证照片率/前',
                '人脸照片率/前',
                '基本信息率/前',
                '联系人率/前',
                '银行卡信息率/前',
                '申请率/前',
                '过件率',
                '放款率',
                '注册-绑卡转化率/前'
              ],
              splitLine: { show: false }
            }
          ],
          // yAxis: [
          //   {}
          // ],]
          yAxis: {
            type: 'value',
            axisLabel: {
              fontSize: 18,
              formatter: function(value) {
                return value + '%'
              }
            }
          },
          series: [
            {
              name: this.productName,
              type: 'bar',
              label: {
                position: 'top', // 标签位置
                show: true,
                color: 'red', // 文字颜色
                formatter: function(params) {
                  if (params.value == 0.00 || params.value == 0) {
                    return '{a|' + params.value + '%' + '}'
                  } else {
                    return '{b|' + params.value + '%' + '}'
                  }
                },
                rich: {
                  a: {
                    color: 'red',
                    fontSize: 16,
                    align: 'center'
                  },
                  b: {
                    color: 'black',
                    fontSize: 14,
                    align: 'center'
                  }


                }
              }

            }
          ]
        },
        //小版本号标题变化
        options: showtite2
      }
      option2 && myChart2.setOption(option2)
    }
  }
}
</script>

<style>
</style>